module.exports = __webpack_public_path__ + "static/media/foco90.315ba717.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/foco90.svg
// module id = 16
// module chunks = 0